import apiClient from "./http";

export const getWorkspaceTemplates = () => apiClient.get("/workspace/templates");

export const getWorkspaceLayouts = () => apiClient.get("/workspace/layouts");
